export interface StudentModel {
  id: number;
  name: string;
  image: string;
  token: string;
  biography: string;
  pass: string;
  responsibleName: string;
  responsibleEmail: string;
  schoolName: string;
  shopLimitDate: string | null;
  hideSalesEndDateForFamily?: boolean;
  flipBookId: number | null;
  flipBookUrl: string | undefined;
  teacher?: Teacher;
  pages?: StudentPage[];
}

interface Teacher {
  email: number;
  name: string;
  userId: string | null;
}

export interface StudentPage {
  id: number;
  value: PageValue;
  position: number;
  name: string;
  done: boolean;
  schema: PageSchemaEnum;
}

type PageValue = {
  text: string | null;
  image_hash: string | null;
};

export interface UpdateBiographyStudentPayload {
  image?: File | null;
  biography?: string;
}

export interface LoadStudentByTokenActionPayload {
  pass?: string;
}

export enum PageSchemaEnum {
  COVER = 1,
  BIOGRAPHY = 2,
  TEXT = 3,
  IMAGE = 4
}
